import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  gap: 8,
  flexWrap: 'wrap',
});
